<template>
  <div>
    <div class="modalContainer row6">
      <header class="modalHeader">
        <p>
          {{ title }}
        </p>
      </header>
      <div class="modalBody alignL">
        <p v-html="contents"></p>
      </div>
      <div class="modalFooter">
        <button @click="onClickClose(true)">{{confirmText}}</button>
        <button @click="onClickClose(false)">{{cancelText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  props:[
    'title', 
    'contents',
    'confirmText',
    'cancelText',
    'response'
  ],
  methods:{
    onClickClose(result){
      this.response.result = result
      this.$emit('close')
    }
  }
}
</script>